module.exports = __webpack_public_path__ + "public-roadmap-1-b446acb7f2650c850f98e30a68de6b67.webp";